"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_REVIEW_CONFIG_DOC_ID = void 0;
exports.APP_REVIEW_CONFIG_DOC_ID = 'app-review-config';
//# sourceMappingURL=AppReviewConfig.js.map